import { BaseLayout } from "@components/pages";
import React from "react";

export const DigitalSignBase = () => {
    return <BaseLayout full />;
};
